import { render } from "./ChatUser.vue?vue&type=template&id=37a90f98&scoped=true"
import script from "./ChatUser.vue?vue&type=script&lang=js"
export * from "./ChatUser.vue?vue&type=script&lang=js"

import "./ChatUser.vue?vue&type=style&index=0&id=37a90f98&lang=scss&scoped=true"

import exportComponent from "D:\\myGithub\\customer-web-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a90f98"]])

export default __exports__